import { Component, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { DbService } from './services/db.service'
import { DeviceDetectorService } from 'ngx-device-detector'
import * as uuid from 'uuid/v1'
import * as moment from 'moment'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  subscription: Subscription
  cookieVisible = true
  
  constructor(public db: DbService, private deviceService: DeviceDetectorService) {
    
    let at = this.db.getQueryVariable('t')
    if (at) this.db.addTag = +at ? +at : 0

    let workday = this.db.getQueryVariable('date')
    if (workday) this.db.selectDate = workday

  }

  ngOnInit() {

    this.subscription = this.db.getMessages().subscribe(message => {
      this.messageHandler(message)
    })

    var c = document.cookie
    var cookies = c.split("; ")
    cookies.forEach(c => {
      var c1 = c.split("=")
      if (c1[0] == 'cookieok') if (c1[1] == '1') this.cookieVisible = false
    })

    this.db.browserInfo = this.deviceService.getDeviceInfo()


  }

  messageHandler(message) {

    //console.log('app.component.ts message', message)

    if (message.cmd == 'browser') {
      this.db.sendMessage('admin', { cmd: 'browser', data: this.db.browserInfo })
    }

  }  

  accept() {
    this.cookieVisible = false
    document.cookie = "cookieok=1" + ";max-age=" + (60 * 60 * 24 * 365).toString();
  }

}

// Browser support
//
// Firefox from 51
// Chrome from 37

